/* eslint-disable no-console */
/* eslint-disable indent */
import { useMemo } from "react";
import { useState, useEffect, useCallback } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/auth";
import adigitalLogo from "../../img/adigital-logo.png";
import screenmediaLogo from "../../img/screenmedia-logo.png";
import visionaLogo from "../../img/visiona-logo.png";
import wecastLogo from "../../img/wecast-logo.png";
import {
  client,
  getClientes,
  getEdificios,
  getIntermediarios,
  // getManualCosts,
  getOportunidades,
  getUsers,
  // log,
  calculateComission,
  getCostosHardware,
  upsertCostoHardware,
  getCostosGestion,
  getCostosPublicidad,
  upsertCostoGestion,
  upsertCostosPublicidad,
} from "../../utils";
import styles from "./stylesER.module.scss";

export const ER = ({ showInDollars = false, setShowInDollars }) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const [clientes, setClientes] = useState({}); // Cambiar de [] a {}
  const [edificios, setEdificios] = useState({});
  const [intermediarios, setIntermediarios] = useState({});
  const [isBuildingCommissionModalOpen, setIsBuildingCommissionModalOpen] = useState(false);
  const [isAgencyModalOpen, setIsAgencyModalOpen] = useState(false);
  const [isCommercialModalOpen, setIsCommercialModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [manualCosts, setManualCosts] = useState({});
  const [oportunidades, setOportunidades] = useState([]);
  const [isOportunidadesLoading, setIsOportunidadesLoading] = useState(true);
  const [selectedAgencyMonth, setSelectedAgencyMonth] = useState(null);
  const [selectedBuildingCommissionMonth, setSelectedBuildingCommissionMonth] = useState(null);
  const [selectedCommercialMonth, setSelectedCommercialMonth] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [users, setUsers] = useState({});
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingConcept, setEditingConcept] = useState(null);
  const [costosGestionData, setCostosGestionData] = useState([]);
  const [isClientesLoading, setIsClientesLoading] = useState(true);
  const [editValue, setEditValue] = useState(0);
  const [costosHardwareData, setCostosHardwareData] = useState([]);
  const [isGestionContenidosModalOpen, setIsGestionContenidosModalOpen] = useState(false);
  const [selectedGestionContenidosMonth, setSelectedGestionContenidosMonth] = useState(null);
  const [isHardwareDetailModalOpen, setIsHardwareDetailModalOpen] = useState(false);
  const [selectedHardwareMonth, setSelectedHardwareMonth] = useState(null);
  const [editandoCosto, setEditandoCosto] = useState(null);
  const [nuevoCosto, setNuevoCosto] = useState("");
  const [negociosCarteleria, setNegociosCarteleria] = useState([]);
  const [nuevoOtros, setNuevoOtros] = useState("");
  const gerenteIds = [1, 4, 10];
  const meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
  const mesesCompletos = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];
  const [costosPublicidadData, setCostosPublicidadData] = useState(
    Array(12)
      .fill()
      .map(() => ({
        servicios_internet: 0,
        software_ds: 0,
        mantenimiento: 0,
      }))
  );

  const { pais } = useAuthContext();

  const navigate = useNavigate();

  const logos = {
    Chile: wecastLogo,
    Perú: visionaLogo,
    Uruguay: screenmediaLogo,
    Region: adigitalLogo,
  };

  const logo = useMemo(() => logos[pais] || visionaLogo, [pais]);

  const localString = useCallback(
    (pais) =>
      ({
        Chile: "es-CL",
        Perú: "es-PE",
      })[pais] || "es-CL",
    []
  );

  const moneda = useCallback(
    (pais) =>
      ({
        Chile: "$ ",
        Perú: "S/ ",
      })[pais] || "$ ",
    []
  );

  const getConvertedImporte = useCallback(
    (oportunidad) =>
      oportunidad.moneda_dolar ? oportunidad.importe * (tiposDeCambio[pais] || 1) : oportunidad.importe,
    [pais]
  );

  const tiposDeCambio = {
    Perú: 3.75,
    Chile: 950,
  };

  const UF_VALUE_CL = 39000;

  const convertirAMonedaLocal = useCallback((valor, moneda, pais) => {
    if (!valor) return 0;
    const num = parseFloat(valor) || 0;

    if (pais === "Chile" && moneda === "UF") {
      return num * UF_VALUE_CL;
    }
    // Perú: PEN, Chile: CLP → ya están en moneda local
    return num;
  }, []);

  // const rate = tiposDeCambio[pais] || 1;

  const getMoneda = useCallback(() => (showInDollars ? "US$ " : moneda(pais)), [showInDollars, pais]);

  // const getLocale = useCallback(() => (showInDollars ? "en-US" : localString(pais)), [showInDollars, pais]);

  // const getDisplayValue = useCallback((value) => (showInDollars ? value / rate : value), [showInDollars, rate]);

  const formatCurrency = useCallback(
    (value, isUF = false) => {
      if (value === null || value === undefined || isNaN(value)) return "-";

      const absValue = Math.abs(value);
      const locale = showInDollars ? "en-US" : localString(pais);
      const currency = showInDollars ? "US$ " : moneda(pais);
      const exchangeRate = tiposDeCambio[pais] || 1;
      const finalValue = showInDollars ? absValue / exchangeRate : absValue;

      const formatted = finalValue.toLocaleString(locale, {
        minimumFractionDigits: isUF ? 2 : 0,
        maximumFractionDigits: isUF ? 2 : 0,
      });

      return `${value < 0 ? "-" : ""}${currency}${formatted}`;
    },
    [pais, localString, moneda, showInDollars]
  );

  const formatFee = useCallback(
    (value, moneda) => {
      if (value === null || value === undefined || isNaN(value)) return "-";

      const absValue = Math.abs(value);
      const locale = localString(pais);
      const formatted = absValue.toLocaleString(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      return `${formatted} ${moneda}`; // Ej: "7.80 UF"
    },
    [pais, localString]
  );

  const costosGestionMensual = useMemo(() => {
    const mapa = Array(12)
      .fill()
      .map(() => ({ software_ds: 0, otros: 0 }));
    costosGestionData.forEach((c) => {
      const mesIndex = parseInt(c.mes, 10) - 1;
      if (mesIndex >= 0 && mesIndex < 12) {
        mapa[mesIndex].software_ds = Number(c.software_ds) || 0;
        mapa[mesIndex].otros = Number(c.otros) || 0;
      }
    });
    return mapa;
  }, [costosGestionData]);

  const conceptosManuales = ["Servicios internet", "Software DS", "Mantenimiento"];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsOportunidadesLoading(true);
        const allOportunidades = await getOportunidades({ pais });
        const filteredOportunidades = allOportunidades.filter(
          (oportunidad) => oportunidad.ano === currentYear && oportunidad.pais === pais
        );
        setOportunidades(filteredOportunidades);
      } catch {
        // Silently ignore errors
      } finally {
        setIsOportunidadesLoading(false);
      }
    };
    fetchData();
  }, [pais, currentYear]);

  useEffect(() => {
    const fetchClientes = async () => {
      try {
        setIsClientesLoading(true);
        const clientesData = await getClientes({ pais });
        if (!clientesData || clientesData.length === 0) {
          console.error("No clientes data returned for pais:", pais);
          return;
        }
        const clientesMap = clientesData.reduce((acc, cliente) => {
          if (!cliente.id) {
            console.warn("Cliente without id:", cliente);
            return acc;
          }
          acc[cliente.id] = { ...cliente, agencia: cliente.agencia || null };
          return acc;
        }, {});
        setClientes(clientesMap);
      } catch (error) {
        console.error("Error fetching clientes:", error);
      } finally {
        setIsClientesLoading(false);
      }
    };
    fetchClientes();
  }, [pais]);

  useEffect(() => {
    const fetchEdificios = async () => {
      try {
        const edificiosData = await getEdificios({ pais });
        if (!edificiosData || edificiosData.length === 0) {
          setEdificios({});
          return;
        }
        const edificiosMap = edificiosData.reduce((acc, edificio) => {
          acc[edificio.id] = edificio; // ← TODO EL OBJETO
          return acc;
        }, {});
        setEdificios(edificiosMap);
      } catch (error) {
        console.error("Error fetching edificios:", error);
        setEdificios({});
      }
    };
    fetchEdificios();
  }, [pais]);

  useEffect(() => {
    const fetchIntermediarios = async () => {
      try {
        const intermediariosData = await getIntermediarios({ pais });
        const intermediariosMap = intermediariosData.reduce((acc, intermediario) => {
          acc[intermediario.id] = intermediario;
          return acc;
        }, {});
        setIntermediarios(intermediariosMap);
      } catch {
        // Silently ignore errors
      }
    };
    fetchIntermediarios();
  }, [pais]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersData = await getUsers();
        const usersMap = usersData.reduce((acc, user) => {
          acc[user.id] = user.nombre || `User ${user.id}`;
          return acc;
        }, {});
        setUsers(usersMap);
      } catch {
        // Silently ignore errors
      }
    };
    fetchUsers();
  }, []);

  // useEffect(() => {
  //   const fetchCosts = async () => {
  //     try {
  //       const session = await client.auth.getSession();
  //       if (!session.data.session) throw new Error("No autenticado para cargar costos");
  //       const costs = await getManualCosts({ pais, ano: currentYear });
  //       setManualCosts(costs || {}); // Asegurar objeto válido
  //     } catch (error) {
  //       log.error("fetchCosts", error);
  //       toast.error("Error cargando costos manuales");
  //     }
  //   };
  //   fetchCosts();
  // }, [pais, currentYear]);

  useEffect(() => {
    const fetchCostos = async () => {
      try {
        const costos = await getCostosGestion({
          pais,
          ano: currentYear,
          _t: Date.now(),
        });
        setCostosGestionData(Array.isArray(costos) ? costos : []);
      } catch (error) {
        console.error("Error:", error);
        setCostosGestionData([]);
      }
    };
    if (pais && currentYear) fetchCostos();
  }, [pais, currentYear]);

  useEffect(() => {
    const fetchNegocios = async () => {
      try {
        const { data, error } = await client
          .from("negocios_carteleria")
          .select("*")
          .eq("pais", pais)
          .neq("eliminada", true);

        if (error) throw error;
        setNegociosCarteleria(data || []);
      } catch {
        toast.error("Error cargando negocios de cartelería");
      }
    };

    fetchNegocios();
  }, [pais]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await getCostosPublicidad({ pais, ano: currentYear });
        setCostosPublicidadData(data);
      } catch (err) {
        console.error("Error cargando costos publicidad:", err);
        setCostosPublicidadData(
          Array(12)
            .fill()
            .map(() => ({
              servicios_internet: 0,
              software_ds: 0,
              mantenimiento: 0,
            }))
        );
      }
    };
    if (pais && currentYear) fetch();
  }, [pais, currentYear]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await getCostosHardware({ pais, ano: currentYear, _t: Date.now() });
        setCostosHardwareData(data || []);
      } catch {
        setCostosHardwareData([]);
      }
    };
    if (pais && currentYear) fetch();
  }, [pais, currentYear, negociosCarteleria]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const mapa = await getCostosGestion({ pais, ano: currentYear });
        setCostosGestionData(mapa);
      } catch {
        setCostosGestionData(
          Array(12)
            .fill()
            .map(() => ({ software_ds: 0, otros: 0 }))
        );
      }
    };
    if (pais && currentYear) fetch();
  }, [pais, currentYear]);

  const getProjectedValue = useCallback(
    (concept, month) => {
      // === BLOQUE A: usar costosPublicidadData ===
      if (conceptosManuales.includes(concept)) {
        const fieldMap = {
          "Servicios internet": "servicios_internet",
          "Software DS": "software_ds",
          Mantenimiento: "mantenimiento",
        };
        const field = fieldMap[concept];

        // Obtener todos los valores guardados del año (meses 1-12)
        const allValues = meses.map((_, i) => {
          const m = i + 1;
          const value = costosPublicidadData[m - 1]?.[field] ?? 0;
          return { month: m, value };
        });

        // Filtrar valores reales (excluyendo el mes actual y valores 0)
        const validValues = allValues.filter((v) => v.month !== month && v.value > 0).map((v) => v.value);

        // Si no hay valores reales, retornar 0
        if (validValues.length === 0) return 0;

        // Promedio
        return validValues.reduce((a, b) => a + b, 0) / validValues.length;
      }

      // === BLOQUE C: usar costosGestionData (tipo + value) ===
      // (si usas costos_gestion_contenidos)
      const field = concept === "Software DS" ? "software_ds" : "otros";
      const allValues = meses.map((_, i) => {
        const m = i + 1;
        const row = costosGestionData.find((c) => parseInt(c.mes, 10) === m);
        const value = row ? Number(row[field]) || 0 : 0;
        return { month: m, value };
      });

      const validValues = allValues.filter((v) => v.month !== month && v.value > 0).map((v) => v.value);

      if (validValues.length === 0) return 0;
      return validValues.reduce((a, b) => a + b, 0) / validValues.length;
    },
    [costosPublicidadData, costosGestionData, conceptosManuales]
  );

  const getValueForMonth = useCallback(
    (concept, month) => {
      let stored = 0;
      let isFromSupabase = false;

      // === BLOQUE A ===
      if (conceptosManuales.includes(concept)) {
        const fieldMap = {
          "Servicios internet": "servicios_internet",
          "Software DS": "software_ds",
          Mantenimiento: "mantenimiento",
        };
        const field = fieldMap[concept];
        stored = costosPublicidadData[month - 1]?.[field] ?? 0;
        isFromSupabase = stored > 0;
      }
      // === BLOQUE C ===
      else if (["Software DS", "Otros"].includes(concept)) {
        const field = concept === "Software DS" ? "software_ds" : "otros";
        const row = costosGestionData.find((c) => parseInt(c.mes, 10) === month);
        stored = row ? Number(row[field]) || 0 : 0;
        isFromSupabase = stored > 0;
      }

      // Si es futuro → 0
      if (month > currentMonth) {
        return { value: 0, isProjected: false };
      }

      // Si tiene valor en Supabase → usar
      if (isFromSupabase) {
        return { value: stored, isProjected: false };
      }

      // Si no tiene valor → proyectar
      const projected = getProjectedValue(concept, month);
      return { value: projected, isProjected: true };
    },
    [costosPublicidadData, costosGestionData, currentMonth, getProjectedValue, conceptosManuales]
  );

  const getYTDManual = useCallback(
    (concept) => meses.slice(0, currentMonth).reduce((acc, _, i) => acc + getValueForMonth(concept, i + 1).value, 0),
    [getValueForMonth, currentMonth]
  );

  const showInvoiceModal = (index) => {
    if (index < currentMonth) {
      setSelectedMonth(index);
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedMonth(null);
  };

  const showBuildingCommissionModal = (index) => {
    if (index < currentMonth) {
      setSelectedBuildingCommissionMonth(index);
      setIsBuildingCommissionModalOpen(true);
    }
  };

  const closeAgencyModal = () => {
    setIsAgencyModalOpen(false);
    setSelectedAgencyMonth(null);
  };

  const closeCommercialModal = () => {
    setIsCommercialModalOpen(false);
    setSelectedCommercialMonth(null);
  };

  const closeBuildingCommissionModal = () => {
    setIsBuildingCommissionModalOpen(false);
    setSelectedBuildingCommissionMonth(null);
  };

  const openHardwareDetailModal = async (monthIndex) => {
    if (monthIndex >= currentMonth) {
      toast.info("No se pueden editar meses futuros");
      return;
    }

    setSelectedHardwareMonth(monthIndex);
    setIsHardwareDetailModalOpen(true);

    try {
      const freshData = await getCostosHardware({ pais, ano: currentYear, _t: Date.now() });
      setCostosHardwareData(freshData || []);
    } catch (err) {
      console.error("Error recargando costos:", err);
    }
  };

  const closeHardwareDetailModal = () => {
    setIsHardwareDetailModalOpen(false);
    setSelectedHardwareMonth(null);
  };

  const valoresMensuales = useMemo(() => {
    if (isOportunidadesLoading) return Array(12).fill(0);
    const valores = Array(12).fill(0);
    const oportunidadesFiltradas = oportunidades.filter((opp) => !opp.eliminada && opp.facturafecha);
    if (oportunidadesFiltradas.length === 0) return valores; // Retorno seguro si no hay datos
    oportunidadesFiltradas.forEach((opp) => {
      const facturaDate = new Date(opp.facturafecha);
      if (isNaN(facturaDate.getTime())) return;
      const monthIndex = facturaDate.getMonth();
      const facturaYear = facturaDate.getFullYear();
      if (monthIndex >= 0 && monthIndex < currentMonth && facturaYear === currentYear) {
        valores[monthIndex] += getConvertedImporte(opp);
      }
    });
    return valores;
  }, [oportunidades, getConvertedImporte, currentMonth, currentYear, isOportunidadesLoading]);

  const facturasPorMes = useMemo(() => {
    if (isOportunidadesLoading) return Array(12).fill([]);
    const facturas = Array(12)
      .fill()
      .map(() => []);
    const oportunidadesFiltradas = oportunidades.filter(
      (opp) => !opp.eliminada && opp.facturafecha && opp.facturanumero && opp.facturanumero !== "E001-XXX"
    );
    if (oportunidadesFiltradas.length === 0) return facturas; // Retorno seguro
    const oportunidadesAgrupadas = oportunidadesFiltradas.reduce((acc, opp) => {
      const facturaDate = new Date(opp.facturafecha);
      if (isNaN(facturaDate.getTime())) {
        console.warn(`Invalid facturafecha for oportunidad ${opp.id}: ${opp.facturafecha}`);
        return acc;
      }
      const monthIndex = facturaDate.getMonth();
      const facturaYear = facturaDate.getFullYear();
      if (monthIndex >= 0 && monthIndex < currentMonth && facturaYear === currentYear) {
        const key = `${opp.facturanumero}-${opp.facturafecha}`;
        if (!acc[key]) {
          acc[key] = {
            facturanumero: opp.facturanumero,
            cliente: opp.cliente,
            importe: 0,
            monthIndex,
          };
        }
        acc[key].importe += getConvertedImporte(opp);
      }
      return acc;
    }, {}); // Inicialización explícita
    Object.values(oportunidadesAgrupadas).forEach((group) => {
      if (group && group.monthIndex !== undefined) {
        // Verificación adicional
        facturas[group.monthIndex].push({
          facturanumero: group.facturanumero,
          cliente: group.cliente || "Sin cliente",
          importe: group.importe,
        });
      }
    });
    return facturas;
  }, [oportunidades, getConvertedImporte, currentMonth, currentYear, isOportunidadesLoading]);

  const valoresMensualesComisionAgencia = useMemo(() => {
    if (isClientesLoading || isOportunidadesLoading) return Array(12).fill(0);
    const valores = Array(12).fill(0);
    oportunidades
      .filter((opp) => !opp.eliminada && opp.facturafecha && opp.client_id)
      .forEach((opp) => {
        const facturaDate = new Date(opp.facturafecha);
        if (isNaN(facturaDate.getTime())) return;
        const monthIndex = facturaDate.getMonth();
        if (monthIndex >= 0 && monthIndex < currentMonth && facturaDate.getFullYear() === currentYear) {
          valores[monthIndex] += calculateComission.calculateAgencyCommission(opp, clientes, intermediarios);
        }
      });
    return valores;
  }, [oportunidades, clientes, intermediarios, currentMonth, currentYear, isClientesLoading, isOportunidadesLoading]);

  const comisionesAgenciaPorMes = useMemo(() => {
    if (isClientesLoading || isOportunidadesLoading) return Array(12).fill([]);
    const comisiones = Array(12)
      .fill()
      .map(() => []);
    oportunidades
      .filter((opp) => !opp.eliminada && opp.facturafecha && opp.client_id)
      .forEach((opp) => {
        const facturaDate = new Date(opp.facturafecha);
        if (isNaN(facturaDate.getTime())) {
          console.warn(`Invalid facturafecha for oportunidad ${opp.id}: ${opp.facturafecha}`);
          return;
        }
        const monthIndex = facturaDate.getMonth();
        if (monthIndex >= 0 && monthIndex < currentMonth && facturaDate.getFullYear() === currentYear) {
          const comision = calculateComission.calculateAgencyCommission(opp, clientes, intermediarios);
          const cliente = clientes[opp.client_id];
          const intermediarioId = cliente?.agencia || null;
          let intermediarioNombre = "Directo";
          let porcentajeComision = 0;
          if (intermediarioId) {
            const intermediario = intermediarios[intermediarioId];
            if (intermediario) {
              intermediarioNombre = intermediario.nombre;
              porcentajeComision = parseFloat(intermediario.comision) || 0;
              if (
                intermediario.comision_2 &&
                intermediario.comision_2_fechainicio &&
                intermediario.comision_2_fechafin &&
                facturaDate >= new Date(intermediario.comision_2_fechainicio) &&
                facturaDate <= new Date(intermediario.comision_2_fechafin)
              ) {
                porcentajeComision = parseFloat(intermediario.comision_2) || porcentajeComision;
              }
            }
          }
          const importeBruto = opp.has_manual_discount
            ? parseFloat(opp.original_amount) || 0
            : parseFloat(opp.importe) || 0;
          const descuento = opp.has_manual_discount ? parseFloat(opp.manual_discount_amount) || 0 : 0;
          const neto = importeBruto - descuento;
          comisiones[monthIndex].push({
            intermediario: intermediarioNombre,
            facturanumero: opp.facturanumero,
            comision,
            porcentaje: porcentajeComision,
            importe: neto,
            oppId: opp.id,
          });
        }
      });
    return comisiones;
  }, [oportunidades, clientes, intermediarios, currentMonth, currentYear, isClientesLoading, isOportunidadesLoading]);

  const valoresMensualesComisiones = useMemo(() => {
    if (isOportunidadesLoading) return Array(12).fill(0);
    const valores = Array(12).fill(0);
    oportunidades
      .filter((opp) => opp.estatus === "100%" && !opp.eliminada && opp.facturafecha)
      .forEach((opp) => {
        const facturaDate = new Date(opp.facturafecha);
        if (isNaN(facturaDate.getTime())) return;
        const monthIndex = facturaDate.getMonth();
        if (monthIndex >= 0 && monthIndex < currentMonth && facturaDate.getFullYear() === currentYear) {
          valores[monthIndex] += calculateComission.calculateBuildingCommission(opp, edificios);
        }
      });
    return valores;
  }, [oportunidades, edificios, currentMonth, currentYear, isOportunidadesLoading]);

  const comisionesEdificiosPorMes = useMemo(() => {
    if (isOportunidadesLoading) {
      return Array(12)
        .fill([])
        .map(() => []);
    }
    const comisiones = Array(12)
      .fill([])
      .map(() => []);
    oportunidades
      .filter((opp) => opp.estatus === "100%" && !opp.eliminada && opp.facturafecha)
      .forEach((opp) => {
        const facturaDate = new Date(opp.facturafecha);
        if (isNaN(facturaDate.getTime())) {
          console.warn(`Invalid facturafecha for oportunidad ${opp.id}: ${opp.facturafecha}`);
          return;
        }
        const monthIndex = facturaDate.getMonth();
        if (monthIndex >= 0 && monthIndex < currentMonth && facturaDate.getFullYear() === currentYear) {
          const comision = calculateComission.calculateBuildingCommission(opp, edificios);
          const cliente = opp.cliente || "Sin cliente";
          comisiones[monthIndex].push({
            facturanumero: opp.facturanumero,
            cliente,
            totalComision: comision,
            oppId: opp.id,
          });
        }
      });
    return comisiones;
  }, [oportunidades, edificios, currentMonth, currentYear, isOportunidadesLoading]);

  const valoresMensualesComisionComercial = useMemo(() => {
    if (isOportunidadesLoading) return { valores: Array(12).fill(0), comisionesPorOportunidad: {} };
    const valores = Array(12).fill(0);
    const comisionesPorOportunidad = {};
    oportunidades
      .filter((opp) => opp.estatus === "100%" && !opp.eliminada && opp.facturafecha)
      .forEach((opp) => {
        const facturaDate = new Date(opp.facturafecha);
        if (isNaN(facturaDate.getTime())) {
          console.warn(`Invalid facturafecha for oportunidad ${opp.id}: ${opp.facturafecha}`);
          return;
        }
        const monthIndex = facturaDate.getMonth();
        if (monthIndex >= 0 && monthIndex < currentMonth && facturaDate.getFullYear() === currentYear) {
          const oppId = opp.id;
          if (!oppId) {
            console.error("Oportunidad sin ID:", opp);
            return;
          }
          const comision = calculateComission.calculateSalesCommission(opp, clientes, intermediarios, edificios);
          comisionesPorOportunidad[oppId] = {
            facturanumero: opp.facturanumero,
            importe: parseFloat(opp.importe) || 0,
            ejecutivo: opp.ejecutivo ? users[opp.ejecutivo] || "Sin Ejecutivo" : "Sin Ejecutivo",
            comisionComercial: comision,
            comisionAgencia: calculateComission.calculateAgencyCommission(opp, clientes, intermediarios),
            comisionEdificios: calculateComission.calculateBuildingCommission(opp, edificios),
            neto:
              (parseFloat(opp.importe) || 0) -
              comision -
              calculateComission.calculateAgencyCommission(opp, clientes, intermediarios),
          };
          valores[monthIndex] += comision;
        }
      });
    return { valores, comisionesPorOportunidad };
  }, [oportunidades, clientes, intermediarios, edificios, users, currentMonth, currentYear, isOportunidadesLoading]);

  const ytdComisionAgencia = useMemo(
    () => valoresMensualesComisionAgencia.slice(0, currentMonth).reduce((acc, val) => acc + val, 0),
    [valoresMensualesComisionAgencia, currentMonth]
  );

  const ytdComisiones = useMemo(
    () => valoresMensualesComisiones.slice(0, currentMonth).reduce((acc, val) => acc + val, 0),
    [valoresMensualesComisiones, currentMonth]
  );

  const ytdComisionComercial = useMemo(
    () => valoresMensualesComisionComercial.valores.slice(0, currentMonth).reduce((acc, val) => acc + val, 0),
    [valoresMensualesComisionComercial, currentMonth]
  );

  const valoresMargenContribucion = useMemo(() => {
    const valores = Array(12).fill(0);
    for (let i = 0; i < 12; i++) {
      if (i < currentMonth) {
        const facturado = valoresMensuales[i] || 0;
        const comisionAgencia = valoresMensualesComisionAgencia[i] || 0;
        const comisionEdificios = valoresMensualesComisiones[i] || 0;
        const comisionComercial = valoresMensualesComisionComercial.valores[i] || 0;

        const costoInternet = getValueForMonth("Servicios internet", i + 1).value || 0;
        const costoSoftware = getValueForMonth("Software DS", i + 1).value || 0;
        const costoMantenimiento = getValueForMonth("Mantenimiento", i + 1).value || 0;

        valores[i] =
          facturado -
          comisionAgencia -
          comisionEdificios -
          comisionComercial -
          costoInternet -
          costoSoftware -
          costoMantenimiento;
      }
    }
    return valores;
  }, [
    valoresMensuales,
    valoresMensualesComisionAgencia,
    valoresMensualesComisiones,
    valoresMensualesComisionComercial,
    getValueForMonth, // ← Añadir dependencia
    currentMonth,
  ]);

  const ytdMargenContribucion = useMemo(
    () =>
      valoresMargenContribucion
        .slice(0, currentMonth)
        .reduce((acc, val) => acc + (typeof val === "number" ? val : 0), 0),
    [valoresMargenContribucion, currentMonth]
  );

  // === INGRESOS HARDWARE ===
  const ingresosHardwareMensual = useMemo(() => {
    const mapa = Array(12).fill(0);
    negociosCarteleria.forEach((n) => {
      if (!n.incluye_hardware) return;
      const fecha = new Date(n.fecha_inicio);
      const mes = fecha.getMonth();
      if (fecha.getFullYear() !== currentYear) return;
      const pantallas = parseInt(n.cantidad_pantallas) || 1;
      if (n.modalidad === "CAPEX") {
        mapa[mes] += Number(n.monto_hardware) || 0;
      } else if (n.modalidad === "OPEX") {
        const cuota = Number(n.cuota_hardware_opex) || 0;
        const plazo = parseInt(n.plazo_contrato_meses) || 0;
        for (let i = 0; i < plazo && mes + i < 12; i++) {
          mapa[mes + i] += cuota * pantallas;
        }
      }
    });
    return mapa;
  }, [negociosCarteleria, currentYear]);

  const costosHardwareMensual = useMemo(() => {
    const mapa = Array(12).fill(0);
    costosHardwareData.forEach((c) => {
      const mesIndex = c.mes - 1;
      if (mesIndex >= 0 && mesIndex < 12) {
        mapa[mesIndex] += Number(c.compra_hardware) || 0;
      }
    });
    return mapa;
  }, [costosHardwareData]);

  const otrosCostosMensual = useMemo(() => {
    const mapa = Array(12).fill(0);
    costosHardwareData.forEach((c) => {
      const mesIndex = parseInt(c.mes, 10) - 1;
      if (mesIndex >= 0 && mesIndex < 12) {
        mapa[mesIndex] += Number(c.otros_costos) || 0;
      }
    });
    return mapa;
  }, [costosHardwareData]);

  // === YTDs ===
  const ytdIngresosHardware = ingresosHardwareMensual.slice(0, currentMonth).reduce((a, b) => a + b, 0);
  const ytdCompraHardware = costosHardwareMensual.slice(0, currentMonth).reduce((a, b) => a + b, 0);
  const ytdOtrosCostos = otrosCostosMensual.slice(0, currentMonth).reduce((a, b) => a + b, 0);
  const margenHardwareMensual = useMemo(
    () => ingresosHardwareMensual.map((ing, i) => ing - costosHardwareMensual[i] - otrosCostosMensual[i]),
    [ingresosHardwareMensual, costosHardwareMensual, otrosCostosMensual]
  );
  const ytdMargenHardware = ytdIngresosHardware - ytdCompraHardware - ytdOtrosCostos;

  const guardarCosto = async (negocioId) => {
    try {
      const compra = parseFloat(nuevoCosto) || 0;
      const otros = parseFloat(nuevoOtros) || 0;

      if (compra < 0 || otros < 0) {
        toast.error("Valores no pueden ser negativos");
        return;
      }

      await upsertCostoHardware({
        negocio_id: Number(negocioId),
        ano: currentYear,
        mes: selectedHardwareMonth + 1,
        compra_hardware: compra,
        otros_costos: otros,
      });

      toast.success("Costos guardados");

      const updated = await getCostosHardware({
        pais,
        ano: currentYear,
        _t: Date.now(),
      });
      setCostosHardwareData(updated || []);

      setEditandoCosto(null);
      setNuevoCosto("");
      setNuevoOtros("");
    } catch (error) {
      console.error("Error guardando costos:", error);
      toast.error("Error al guardar");
    }
  };

  const negociosDelMes = useMemo(() => {
    if (selectedHardwareMonth === null) return [];
    return negociosCarteleria.filter((n) => {
      const fecha = new Date(n.fecha_inicio);
      return fecha.getFullYear() === currentYear && fecha.getMonth() === selectedHardwareMonth;
    });
  }, [negociosCarteleria, selectedHardwareMonth, currentYear]);

  const openEditModal = (concept, monthIndex) => {
    const month = monthIndex + 1;
    if (month > currentMonth) {
      toast.info("No se pueden editar meses futuros");
      return;
    }
    const initialValue = getValueForMonth(concept, month).value;
    setEditValue(initialValue);
    setEditingConcept({ concept, month });
    setIsEditModalOpen(true);
  };

  const detalleGestionContenidosPorMes = useMemo(() => {
    const detalle = Array(12)
      .fill()
      .map(() => []);

    negociosCarteleria.forEach((negocio) => {
      // 1. Filtrar contratos válidos
      if (
        negocio.eliminada === true ||
        negocio.estado !== "Activo" ||
        !negocio.fecha_inicio ||
        !negocio.plazo_contrato_meses
      )
        return;

      const fechaInicio = new Date(negocio.fecha_inicio);
      const plazoMeses = parseInt(negocio.plazo_contrato_meses) || 0;
      if (plazoMeses === 0) return;

      const fechaFin = new Date(fechaInicio);
      fechaFin.setMonth(fechaInicio.getMonth() + plazoMeses);
      fechaFin.setDate(fechaFin.getDate() - 1); // último día del mes

      const pantallas = parseInt(negocio.cantidad_pantallas) || 1;
      const gestionUnitario = parseFloat(negocio.fee_gestion_unitario) || 0;
      const contenidosUnitario =
        negocio.incluye_contenidos === true ? parseFloat(negocio.fee_contenidos_unitario) || 0 : 0;

      // 2. Convertir a moneda local (CLP o PEN)
      const gestionLocal = convertirAMonedaLocal(gestionUnitario * pantallas, negocio.moneda_gestion, pais);
      const contenidosLocal = convertirAMonedaLocal(contenidosUnitario * pantallas, negocio.moneda_contenidos, pais);
      const totalLocal = gestionLocal + contenidosLocal;

      if (totalLocal === 0) return;

      // 3. Obtener nombre del cliente o edificio
      let nombreReferencia = `ID ${negocio.referencia_id}`;
      if (negocio.tipo_vertical === "TD" && clientes[negocio.referencia_id]) {
        nombreReferencia = clientes[negocio.referencia_id]; // string
      } else if (negocio.tipo_vertical === "EO" && edificios[negocio.referencia_id]) {
        nombreReferencia = edificios[negocio.referencia_id]?.edificio || `ID ${negocio.referencia_id}`;
      }

      // 4. Asignar a cada mes activo
      for (let m = 0; m < 12; m++) {
        const primerDiaMes = new Date(currentYear, m, 1);
        const ultimoDiaMes = new Date(currentYear, m + 1, 0);

        if (primerDiaMes >= fechaInicio && ultimoDiaMes <= fechaFin) {
          detalle[m].push({
            id: negocio.id,
            tipo: negocio.tipo_vertical,
            nombre: nombreReferencia,
            pantallas,
            gestionUnitario,
            gestionMoneda: negocio.moneda_gestion,
            contenidosUnitario,
            contenidosMoneda: negocio.moneda_contenidos,
            totalLocal,
          });
        }
      }
    });

    return detalle.map((mes) =>
      mes.sort((a, b) => {
        // 1. Primero EO, luego TD
        if (a.tipo !== b.tipo) {
          return a.tipo === "EO" ? -1 : 1;
        }
        // 2. Orden alfabético por nombre
        return a.nombre.localeCompare(b.nombre);
      })
    );
  }, [negociosCarteleria, clientes, edificios, currentYear, pais, convertirAMonedaLocal]);

  const ingresosGestionContenidosMensual = useMemo(() => {
    const mapa = Array(12).fill(0); // [ENE, FEB, ..., DIC]
    negociosCarteleria.forEach((negocio) => {
      // 1. Filtrar solo contratos relevantes
      if (negocio.eliminada === true || negocio.estado !== "Activo" || !negocio.fecha_inicio) return;
      const fechaInicio = new Date(negocio.fecha_inicio);
      const plazoMeses = parseInt(negocio.plazo_contrato_meses) || 0;
      if (plazoMeses === 0) return;
      const fechaFin = new Date(fechaInicio);
      fechaFin.setMonth(fechaInicio.getMonth() + plazoMeses);
      fechaFin.setDate(fechaFin.getDate() - 1); // último día del mes de fin
      const pantallas = parseInt(negocio.cantidad_pantallas) || 1;
      // 2. Calcular ingresos unitarios
      const gestionUnitario = parseFloat(negocio.fee_gestion_unitario) || 0;
      const contenidosUnitario =
        negocio.incluye_contenidos === true ? parseFloat(negocio.fee_contenidos_unitario) || 0 : 0;
      // 3. Convertir a moneda local (CLP o PEN)
      let ingresoLocal = 0;
      if (gestionUnitario > 0) {
        ingresoLocal += convertirAMonedaLocal(gestionUnitario * pantallas, negocio.moneda_gestion, pais);
      }
      if (contenidosUnitario > 0) {
        ingresoLocal += convertirAMonedaLocal(contenidosUnitario * pantallas, negocio.moneda_contenidos, pais);
      }
      if (ingresoLocal === 0) return;
      // 4. Asignar a cada mes dentro del rango
      for (let m = 0; m < 12; m++) {
        const primerDiaMes = new Date(currentYear, m, 1);
        const ultimoDiaMes = new Date(currentYear, m + 1, 0); // último día
        // ¿El mes está dentro del contrato?
        if (primerDiaMes >= fechaInicio && ultimoDiaMes <= fechaFin) {
          mapa[m] += ingresoLocal;
        }
      }
    });
    return mapa;
  }, [negociosCarteleria, currentYear, pais, convertirAMonedaLocal]);

  const calcularCostoSoftwareEstimado = useCallback(
    (monthIndex) => {
      const pantallasActivas = detalleGestionContenidosPorMes[monthIndex].reduce(
        (sum, item) => sum + item.pantallas,
        0
      );

      const costoUSD = pantallasActivas * 11;
      const costoLocal = pais === "Chile" ? costoUSD * 950 : costoUSD * 3.75;
      return Math.round(costoLocal);
    },
    [detalleGestionContenidosPorMes, pais]
  );

  const ytdSoftwareDS = useMemo(() => {
    let total = 0;
    for (let i = 0; i < currentMonth; i++) {
      const valor = costosGestionMensual[i].software_ds;
      total += valor > 0 ? valor : calcularCostoSoftwareEstimado(i);
    }
    return total;
  }, [costosGestionMensual, currentMonth, calcularCostoSoftwareEstimado]);

  const ytdOtros = costosGestionMensual.slice(0, currentMonth).reduce((a, c) => a + c.otros, 0);

  const margenGestionContenidosMensual = useMemo(
    () =>
      Array(12)
        .fill(0)
        .map((_, i) => {
          if (i >= currentMonth) return 0;

          const ingresos = ingresosGestionContenidosMensual[i] || 0;
          const softwareSupabase = costosGestionMensual[i].software_ds;
          const softwareEstimado = calcularCostoSoftwareEstimado(i);
          const softwareUsado = softwareSupabase > 0 ? softwareSupabase : softwareEstimado;
          const otros = costosGestionMensual[i].otros || 0;

          return ingresos - softwareUsado - otros;
        }),
    [ingresosGestionContenidosMensual, costosGestionMensual, currentMonth, calcularCostoSoftwareEstimado]
  );

  const ytdMargenGestionContenidos = useMemo(
    () => margenGestionContenidosMensual.slice(0, currentMonth).reduce((sum, val) => sum + val, 0),
    [margenGestionContenidosMensual, currentMonth]
  );

  // === GUARDAR UNIFICADO ===
  const saveCost = async () => {
    if (!editingConcept) return;
    const { concept, month, tipo } = editingConcept;

    try {
      // === BLOQUE A: Publicidad (nuevos costos fijos) ===
      if (conceptosManuales.includes(concept)) {
        const fieldMap = {
          "Servicios internet": "servicios_internet",
          "Software DS": "software_ds",
          Mantenimiento: "mantenimiento",
        };

        const field = fieldMap[concept];
        if (!field) throw new Error("Concepto no mapeado");

        await upsertCostosPublicidad({
          pais,
          ano: currentYear,
          mes: month,
          [field]: editValue,
        });

        const updated = await getCostosPublicidad({ pais, ano: currentYear });
        setCostosPublicidadData(updated);
        toast.success("Costo de publicidad guardado");
      }

      // === BLOQUE C: Gestión y Contenidos (tu tabla actual) ===
      else if (["Software DS", "Otros"].includes(concept)) {
        await upsertCostoGestion({
          negocio_id: null,
          pais,
          ano: currentYear,
          mes: month,
          tipo, // ← TU TABLA SÍ TIENE `tipo`
          value: editValue,
        });

        const mapa = await getCostosGestion({ pais, ano: currentYear });
        setCostosGestionData(mapa);
        toast.success("Costo de gestión guardado");
      }

      // === BLOQUE B: Hardware (sin cambios) ===
      else if (["Compra hardware", "Otros costos"].includes(concept)) {
        const tipoHardware = concept.includes("Compra") ? "compra_hardware" : "otros_costos";
        const negociosDelMes = negociosCarteleria.filter((n) => {
          if (n.estado !== "Activo" || !n.fecha_inicio || !n.plazo_contrato_meses) return false;
          const fechaInicio = new Date(n.fecha_inicio);
          const fechaFin = new Date(fechaInicio);
          fechaFin.setMonth(fechaInicio.getMonth() + parseInt(n.plazo_contrato_meses));
          fechaFin.setDate(fechaFin.getDate() - 1);
          const mesActual = new Date(currentYear, month - 1, 1);
          const ultimoDiaMes = new Date(currentYear, month, 0);
          return mesActual >= fechaInicio && ultimoDiaMes <= fechaFin;
        });

        if (negociosDelMes.length === 0) {
          toast.error("No hay negocios en este mes");
          return;
        }

        const promises = negociosDelMes.map((n) =>
          upsertCostoHardware({
            negocio_id: n.id,
            ano: currentYear,
            mes: month,
            [tipoHardware]: editValue,
          })
        );

        await Promise.all(promises);
        const updated = await getCostosHardware({ pais, ano: currentYear });
        setCostosHardwareData(updated);
        toast.success("Costos de hardware guardados");
      }

      closeEditModal();
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error al guardar");
    }
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setEditingConcept(null);
    setEditValue(0); // Resetear el valor del input
  };

  const ytdIngresosGestionContenidos = useMemo(
    () => ingresosGestionContenidosMensual.slice(0, currentMonth).reduce((acc, val) => acc + val, 0),
    [ingresosGestionContenidosMensual, currentMonth]
  );

  const showGestionContenidosModal = (monthIndex) => {
    if (monthIndex < currentMonth && detalleGestionContenidosPorMes[monthIndex].length > 0) {
      setSelectedGestionContenidosMonth(monthIndex);
      setIsGestionContenidosModalOpen(true);
    }
  };

  const closeGestionContenidosModal = () => {
    setIsGestionContenidosModalOpen(false);
    setSelectedGestionContenidosMonth(null);
  };

  const getNombreNegocio = useCallback(
    (n) => {
      if (n.tipo_vertical === "TD") {
        return clientes[n.referencia_id]?.nombre || `Cliente ${n.referencia_id}`;
      }
      return edificios[n.referencia_id]?.edificio || `Edificio ${n.referencia_id}`;
    },
    [clientes, edificios]
  );

  // === TOTALES FINALES ===
  const totalFacturacion = useMemo(
    () =>
      valoresMensuales.slice(0, currentMonth).reduce((a, b) => a + b, 0) +
      ingresosHardwareMensual.slice(0, currentMonth).reduce((a, b) => a + b, 0) +
      ingresosGestionContenidosMensual.slice(0, currentMonth).reduce((a, b) => a + b, 0),
    [valoresMensuales, ingresosHardwareMensual, ingresosGestionContenidosMensual, currentMonth]
  );

  const totalCostos = useMemo(
    () =>
      // Costos A
      valoresMensualesComisionAgencia.slice(0, currentMonth).reduce((a, b) => a + b, 0) +
      valoresMensualesComisiones.slice(0, currentMonth).reduce((a, b) => a + b, 0) +
      valoresMensualesComisionComercial.valores.slice(0, currentMonth).reduce((a, b) => a + b, 0) +
      // Costos manuales A
      conceptosManuales.reduce((sum, c) => sum + getYTDManual(c), 0) +
      // Costos B
      ytdCompraHardware +
      ytdOtrosCostos +
      // Costos C
      ytdSoftwareDS +
      ytdOtros,
    [
      valoresMensualesComisionAgencia,
      valoresMensualesComisiones,
      valoresMensualesComisionComercial,
      ytdCompraHardware,
      ytdOtrosCostos,
      ytdSoftwareDS,
      ytdOtros,
      currentMonth,
      getYTDManual,
      conceptosManuales,
    ]
  );

  const margenFinal = totalFacturacion - totalCostos;

  const openEditGestion = (monthIndex, tipo) => {
    if (monthIndex >= currentMonth) {
      toast.info("No se pueden editar meses futuros");
      return;
    }

    const mes = monthIndex + 1;
    const valorActual = costosGestionMensual[monthIndex][tipo] || 0;

    setEditingConcept({
      concept: tipo === "software_ds" ? "Software DS" : "Otros",
      month: mes,
      tipo,
    });
    setEditValue(valorActual);
    setIsEditModalOpen(true);
  };

  return (
    <div className={styles.ER}>
      <div className="mb-4 mt-3">
        <img src={logo} alt={`${pais} Logo`} className="logo" onClick={() => navigate("/admin")} />
      </div>
      {meses &&
        currentMonth !== undefined &&
        !isOportunidadesLoading &&
        !isClientesLoading &&
        valoresMensuales &&
        valoresMensualesComisionAgencia &&
        valoresMensualesComisiones &&
        valoresMensualesComisionComercial && (
          <table className={styles.tableER}>
            <thead>
              <tr>
                <th className={styles.conceptCell}>Concepto</th>
                {meses.map((mes, index) => (
                  <th key={index} className={styles.valueCell}>
                    {mes}
                  </th>
                ))}
                <th className={styles.totalCellHead}>YTD</th>
              </tr>
            </thead>
            <tbody>
              <tr className={styles.facturacionRow}>
                <td className={styles.conceptCell}>Facturación</td>
                {(() => {
                  const facturacionMensual = Array(12).fill(0);
                  for (let i = 0; i < 12; i++) {
                    if (i < currentMonth) {
                      facturacionMensual[i] =
                        (valoresMensuales[i] || 0) +
                        (ingresosHardwareMensual[i] || 0) +
                        (ingresosGestionContenidosMensual[i] || 0);
                    }
                  }
                  return facturacionMensual;
                })().map((val, i) => (
                  <td key={i} className="text-end">
                    {i < currentMonth ? formatCurrency(val) : "-"}
                  </td>
                ))}
                <td className={styles.totalCell}>
                  {formatCurrency(
                    valoresMensuales.slice(0, currentMonth).reduce((a, b) => a + b, 0) +
                      ingresosHardwareMensual.slice(0, currentMonth).reduce((a, b) => a + b, 0) +
                      ingresosGestionContenidosMensual.slice(0, currentMonth).reduce((a, b) => a + b, 0)
                  )}
                </td>
              </tr>
              <tr className={styles.sectionHeader}>
                <td className={styles.conceptCell}>A - Publicidad</td>
                {valoresMensuales.map((valor, index) => (
                  <td key={index}>
                    <div
                      onClick={() => showInvoiceModal(index)}
                      style={{
                        cursor: index < currentMonth && facturasPorMes[index].length > 0 ? "pointer" : "default",
                      }}
                    >
                      {index < currentMonth ? formatCurrency(valor) : "-"}
                    </div>
                  </td>
                ))}
                <td className={styles.totalCell}>
                  {formatCurrency(valoresMensuales.slice(0, currentMonth).reduce((acc, val) => acc + val, 0))}
                </td>
              </tr>
              <tr>
                <td className={styles.conceptCell}>Comisión agencias</td>
                {valoresMensualesComisionAgencia.map((valor, index) => (
                  <td key={index} className={styles.valueCell}>
                    <div
                      onClick={() => {
                        setSelectedAgencyMonth(index);
                        setIsAgencyModalOpen(true);
                      }}
                      style={{
                        cursor:
                          index < currentMonth && comisionesAgenciaPorMes[index].length > 0 ? "pointer" : "default",
                      }}
                    >
                      {index < currentMonth ? formatCurrency(valor) : "-"}
                    </div>
                  </td>
                ))}
                <td className={styles.totalCell}>{formatCurrency(ytdComisionAgencia)}</td>
              </tr>
              <tr>
                <td className={styles.conceptCell}>Comisión edificios</td>
                {valoresMensualesComisiones.map((valor, index) => (
                  <td key={index}>
                    <div
                      onClick={() => showBuildingCommissionModal(index)}
                      style={{
                        cursor:
                          index < currentMonth && comisionesEdificiosPorMes[index].length > 0 ? "pointer" : "default",
                      }}
                    >
                      {index < currentMonth ? formatCurrency(valor) : "-"}
                    </div>
                  </td>
                ))}
                <td className={styles.totalCell}>{formatCurrency(ytdComisiones)}</td>
              </tr>
              <tr>
                <td className={styles.conceptCell}>Comisión comercial</td>
                {valoresMensualesComisionComercial.valores.map((valor, index) => (
                  <td key={index}>
                    <div
                      onClick={() => {
                        setSelectedCommercialMonth(index);
                        setIsCommercialModalOpen(true);
                      }}
                      style={{
                        cursor:
                          index < currentMonth &&
                          oportunidades.some((opp) => {
                            const facturaDate = new Date(opp.facturafecha);
                            return !isNaN(facturaDate.getTime()) && facturaDate.getMonth() === index && opp.ejecutivo;
                          })
                            ? "pointer"
                            : "default",
                      }}
                    >
                      {index < currentMonth ? formatCurrency(valor) : "-"}
                    </div>
                  </td>
                ))}
                <td className={styles.totalCell}>{formatCurrency(ytdComisionComercial)}</td>
              </tr>
              {conceptosManuales.map((concept) => {
                const ytdManual = getYTDManual(concept);
                const hasProjectedInYTD = meses
                  .slice(0, currentMonth)
                  .some((_, i) => getValueForMonth(concept, i + 1).isProjected);

                return (
                  <tr key={concept}>
                    <td className={styles.conceptCell}>{concept}</td>
                    {meses.map((_, index) => {
                      const month = index + 1;
                      const { value, isProjected } = getValueForMonth(concept, month);
                      const isFuture = month > currentMonth;

                      return (
                        <td key={index}>
                          <div
                            onClick={() => !isFuture && openEditModal(concept, index)}
                            style={{
                              cursor: !isFuture ? "pointer" : "default",
                              backgroundColor: isProjected && !isFuture ? "#fff9c4" : "transparent",
                            }}
                            title={isProjected && !isFuture ? "Valor proyectado" : ""}
                          >
                            {month <= currentMonth ? formatCurrency(value) : "-"}
                          </div>
                        </td>
                      );
                    })}
                    <td
                      className={styles.totalCell}
                      style={{ backgroundColor: hasProjectedInYTD ? "#fff9c4" : "transparent" }}
                    >
                      {formatCurrency(ytdManual)}
                    </td>
                  </tr>
                );
              })}
              <tr className={styles.marginRow}>
                <td className={styles.conceptCellMargen}>Margen de contribución</td>
                {valoresMargenContribucion.map((valor, index) => (
                  <td key={index}>
                    <div className={valor < 0 ? styles.marginNegative : ""}>
                      {index < currentMonth ? formatCurrency(valor) : "-"}
                    </div>
                  </td>
                ))}
                <td className={styles.totalCell}>
                  <div className={ytdMargenContribucion < 0 ? styles.marginNegative : ""}>
                    {formatCurrency(ytdMargenContribucion)}
                  </div>
                </td>
              </tr>
              {/* B - Hardware */}
              <tr className={styles.sectionHeader}>
                <td className={styles.conceptCell}>B - Hardware</td>
                {ingresosHardwareMensual.map((val, i) => (
                  <td key={i} className="text-end">
                    {i < currentMonth ? formatCurrency(val) : "-"}
                  </td>
                ))}
                <td className={styles.totalCell}>{formatCurrency(ytdIngresosHardware)}</td>
              </tr>

              {/* Compra hardware */}
              <tr>
                <td className={styles.conceptCell}>Compra hardware</td>
                {costosHardwareMensual.map((val, i) => (
                  <td
                    key={i}
                    onClick={() => i < currentMonth && openHardwareDetailModal(i)}
                    style={{ cursor: i < currentMonth ? "pointer" : "default" }}
                  >
                    {i < currentMonth ? formatCurrency(val) : "-"}
                  </td>
                ))}
                <td className={styles.totalCell}>{formatCurrency(ytdCompraHardware)}</td>
              </tr>

              {/* Otros costos */}
              <tr>
                <td className={styles.conceptCell}>Otros costos</td>
                {otrosCostosMensual.map((val, i) => (
                  <td
                    key={i}
                    onClick={() => i < currentMonth && openHardwareDetailModal(i)}
                    style={{ cursor: i < currentMonth ? "pointer" : "default" }}
                  >
                    {i < currentMonth ? formatCurrency(val) : "-"}
                  </td>
                ))}
                <td className={styles.totalCell}>{formatCurrency(ytdOtrosCostos)}</td>
              </tr>
              {/* Margen de contribución */}
              <tr className={styles.marginRow}>
                <td className={styles.conceptCellMargen}>Margen de contribución</td>
                {margenHardwareMensual.map((val, i) => (
                  <td key={i} className="text-end">
                    <div className={val < 0 ? styles.marginNegative : ""}>
                      {i < currentMonth ? formatCurrency(val) : "-"}
                    </div>
                  </td>
                ))}
                <td className={styles.totalCell}>
                  <div className={ytdMargenHardware < 0 ? styles.marginNegative : ""}>
                    {formatCurrency(ytdMargenHardware)}
                  </div>
                </td>
              </tr>
              {/* === C - GESTIÓN Y CONTENIDOS === */}
              <tr className={styles.sectionHeader}>
                <td className={styles.conceptCell}>C - Gestión y Contenidos</td>
                {ingresosGestionContenidosMensual.map((val, i) => (
                  <td
                    key={i}
                    className="text-end"
                    style={{
                      cursor: i < currentMonth && detalleGestionContenidosPorMes[i].length > 0 ? "pointer" : "default",
                    }}
                    onClick={() => showGestionContenidosModal(i)}
                  >
                    {i < currentMonth ? formatCurrency(val) : "-"}
                  </td>
                ))}
                <td className="text-end font-weight-bold">{formatCurrency(ytdIngresosGestionContenidos)}</td>
              </tr>

              <tr>
                <td className={styles.conceptCell}>Software DS</td>
                {costosGestionData.map((c, i) => {
                  const valorSupabase = c.software_ds;
                  const esEstimado = i < currentMonth && (!valorSupabase || valorSupabase === 0);
                  const valorMostrado = esEstimado ? calcularCostoSoftwareEstimado(i) : valorSupabase;
                  return (
                    <td
                      key={i}
                      className="text-end"
                      style={{
                        cursor: i < currentMonth ? "pointer" : "default",
                        backgroundColor: esEstimado ? "#fff9c4" : "transparent",
                      }}
                      onClick={() => i < currentMonth && openEditGestion(i, "software_ds")}
                      title={esEstimado ? "Estimado: 11 USD x pantalla" : ""}
                    >
                      {i < currentMonth ? formatCurrency(valorMostrado) : "-"}
                    </td>
                  );
                })}
                <td className={styles.totalCell}>{formatCurrency(ytdSoftwareDS)}</td>
              </tr>

              {/* Otros */}
              <tr>
                <td className={styles.conceptCell}>Otros</td>
                {costosGestionData.map((c, i) => (
                  <td
                    key={i}
                    className="text-end"
                    style={{ cursor: i < currentMonth ? "pointer" : "default" }}
                    onClick={() => i < currentMonth && openEditGestion(i, "otros")}
                  >
                    {i < currentMonth ? formatCurrency(c.otros) : "-"}
                  </td>
                ))}
                <td className={styles.totalCell}>{formatCurrency(ytdOtros)}</td>
              </tr>

              <tr className={styles.marginRow}>
                <td className={styles.conceptCellMargen}>Margen de contribución</td>
                {margenGestionContenidosMensual.map((val, i) => (
                  <td key={i} className="text-end">
                    <div className={val < 0 ? styles.marginNegative : ""}>
                      {i < currentMonth ? formatCurrency(val) : "-"}
                    </div>
                  </td>
                ))}
                <td className={styles.totalCell}>
                  <div className={ytdMargenGestionContenidos < 0 ? styles.marginNegative : ""}>
                    {formatCurrency(ytdMargenGestionContenidos)}
                  </div>
                </td>
              </tr>
              {/* === TOTALES FINALES === */}
              <tr className={styles.totalCostosRow}>
                <td className={styles.conceptCell}>Costos Totales</td>
                {(() => {
                  const costosMensuales = Array(12).fill(0);
                  for (let i = 0; i < 12; i++) {
                    if (i < currentMonth) {
                      costosMensuales[i] =
                        // A
                        (valoresMensualesComisionAgencia[i] || 0) +
                        (valoresMensualesComisiones[i] || 0) +
                        (valoresMensualesComisionComercial.valores[i] || 0) +
                        // Manuales A
                        conceptosManuales.reduce((sum, c) => {
                          const { value } = getValueForMonth(c, i + 1);
                          return sum + (value || 0);
                        }, 0) +
                        // B
                        (costosHardwareMensual[i] || 0) +
                        (otrosCostosMensual[i] || 0) +
                        // C
                        (costosGestionMensual[i]?.software_ds || 0) +
                        (costosGestionMensual[i]?.otros || 0);
                    }
                  }
                  return costosMensuales;
                })().map((val, i) => (
                  <td key={i} className="text-end">
                    {i < currentMonth ? formatCurrency(val) : "-"}
                  </td>
                ))}
                <td className={styles.totalCell}>{formatCurrency(totalCostos)}</td>
              </tr>

              <tr className={styles.margenFinalRow}>
                <td className={styles.conceptCellMargen}>Contribución Total</td>
                {(() => {
                  const margenMensual = Array(12).fill(0);
                  for (let i = 0; i < 12; i++) {
                    if (i < currentMonth) {
                      const facturado =
                        (valoresMensuales[i] || 0) +
                        (ingresosHardwareMensual[i] || 0) +
                        (ingresosGestionContenidosMensual[i] || 0);
                      const costos =
                        (valoresMensualesComisionAgencia[i] || 0) +
                        (valoresMensualesComisiones[i] || 0) +
                        (valoresMensualesComisionComercial.valores[i] || 0) +
                        conceptosManuales.reduce((sum, c) => {
                          const { value } = getValueForMonth(c, i + 1);
                          return sum + (value || 0);
                        }, 0) +
                        (costosHardwareMensual[i] || 0) +
                        (otrosCostosMensual[i] || 0) +
                        (costosGestionMensual[i]?.software_ds || 0) +
                        (costosGestionMensual[i]?.otros || 0);
                      margenMensual[i] = facturado - costos;
                    }
                  }
                  return margenMensual;
                })().map((val, i) => (
                  <td key={i} className="text-end">
                    <div className={val < 0 ? styles.marginNegative : ""}>
                      {i < currentMonth ? formatCurrency(val) : "-"}
                    </div>
                  </td>
                ))}
                <td className={styles.totalCell}>
                  <div className={margenFinal < 0 ? styles.marginNegative : ""}>{formatCurrency(margenFinal)}</div>
                </td>
              </tr>
            </tbody>
          </table>
        )}
      {isModalOpen && selectedMonth !== null && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <h3>Detalle facturación - {mesesCompletos[selectedMonth]}</h3>
            <table className={styles.modalTable}>
              <thead>
                <tr>
                  <th className={styles.modalFacturaHeader}>Factura</th>
                  <th className={styles.modalClienteHeader}>Cliente</th>
                  <th className={styles.modalImporteHeader}>Importe</th>
                </tr>
              </thead>
              <tbody>
                {facturasPorMes[selectedMonth].map((f, i) => (
                  <tr key={i}>
                    <td className={styles.modalFacturaData}>{f.facturanumero}</td>
                    <td className={styles.modalClienteData}>{f.cliente}</td>
                    <td className={styles.modalImporteData}>{formatCurrency(f.importe)}</td>
                  </tr>
                ))}
                {facturasPorMes[selectedMonth].length > 0 && (
                  <tr className={styles.modalTotal}>
                    <td colSpan="2">
                      <strong>Total</strong>
                    </td>
                    <td className={styles.modalImporteData}>
                      <strong>
                        {formatCurrency(facturasPorMes[selectedMonth].reduce((s, c) => s + c.importe, 0))}
                      </strong>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className={styles.modalActions}>
              <button className={styles.btnClose} onClick={closeModal}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
      {isAgencyModalOpen && selectedAgencyMonth !== null && (
        <div className={styles.modalOverlay} onClick={closeAgencyModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <h3>Comisión agencias - {mesesCompletos[selectedAgencyMonth]}</h3>
            <table className={styles.modalTable}>
              <thead>
                <tr>
                  <th className={styles.agencyFacturaHeader}>Factura</th>
                  <th className={styles.agencyClienteHeader}>Cliente</th>
                  <th className={styles.agencyIntermediarioHeader}>Intermediario</th>
                  <th className={styles.agencyImporteHeader}>Importe</th>
                  <th className={styles.agencyPorcentajeHeader}>%</th>
                  <th className={styles.agencyComisionHeader}>Comisión</th>
                </tr>
              </thead>
              <tbody>
                {comisionesAgenciaPorMes[selectedAgencyMonth].map((c, i) => (
                  <tr key={i}>
                    <td className={styles.agencyFacturaData}>{c.facturanumero}</td>
                    <td className={styles.agencyClienteData}>
                      {oportunidades.find((o) => o.facturanumero === c.facturanumero)?.cliente || "—"}
                    </td>
                    <td className={styles.agencyIntermediarioData}>{c.intermediario}</td>
                    <td className={styles.agencyImporteData}>{formatCurrency(c.importe)}</td>
                    <td className={styles.agencyPorcentajeData}>{c.porcentaje}%</td>
                    <td className={styles.agencyComisionData}>{formatCurrency(c.comision)}</td>
                  </tr>
                ))}
                {comisionesAgenciaPorMes[selectedAgencyMonth].length > 0 && (
                  <tr className={styles.modalTotal}>
                    <td colSpan="5">
                      <strong>Total</strong>
                    </td>
                    <td className={styles.agencyComisionData}>
                      <strong>
                        {formatCurrency(
                          comisionesAgenciaPorMes[selectedAgencyMonth].reduce((s, c) => s + c.comision, 0)
                        )}
                      </strong>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className={styles.modalActions}>
              <button className={styles.btnClose} onClick={closeAgencyModal}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
      {isBuildingCommissionModalOpen && selectedBuildingCommissionMonth !== null && (
        <div className={styles.modalOverlay} onClick={closeBuildingCommissionModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <h3>Detalle comisión edificios - {mesesCompletos[selectedBuildingCommissionMonth]}</h3>
            <table className={styles.modalTable}>
              <thead>
                <tr>
                  <th className={styles.buildingFacturaHeader}>Factura</th>
                  <th className={styles.buildingClienteHeader}>Cliente</th>
                  <th className={styles.buildingComisionHeader}>Comisión {getMoneda()}</th>
                </tr>
              </thead>
              <tbody>
                {comisionesEdificiosPorMes[selectedBuildingCommissionMonth].map((comision, i) => (
                  <tr key={i}>
                    <td className={styles.buildingFacturaData}>{comision.facturanumero}</td>
                    <td className={styles.buildingClienteData}>{comision.cliente}</td>
                    <td className={styles.buildingComisionData}>{formatCurrency(comision.totalComision)}</td>
                  </tr>
                ))}
                {comisionesEdificiosPorMes[selectedBuildingCommissionMonth].length > 0 && (
                  <tr className={styles.modalTotal}>
                    <td colSpan="2">
                      <strong>Total</strong>
                    </td>
                    <td className={styles.buildingComisionData}>
                      <strong>
                        {formatCurrency(
                          comisionesEdificiosPorMes[selectedBuildingCommissionMonth].reduce(
                            (sum, curr) => sum + curr.totalComision,
                            0
                          )
                        )}
                      </strong>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className={styles.modalActions}>
              <button className={styles.btnClose} onClick={closeBuildingCommissionModal}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
      {isCommercialModalOpen && selectedCommercialMonth !== null && (
        <div className={styles.modalOverlay} onClick={closeCommercialModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <h3>Detalle comisión comercial - {mesesCompletos[selectedCommercialMonth]}</h3>

            {/* RESUMEN POR EJECUTIVO */}
            <div className={styles.comercialSummary}>
              <h4>Resumen por Ejecutivo</h4>
              {Object.entries(
                oportunidades
                  .filter(
                    (opp) =>
                      opp.estatus === "100%" &&
                      !opp.eliminada &&
                      opp.facturafecha &&
                      !isNaN(new Date(opp.facturafecha).getTime()) &&
                      new Date(opp.facturafecha).getMonth() === selectedCommercialMonth
                  )
                  .reduce((acc, opp) => {
                    const facturaDate = new Date(opp.facturafecha);
                    const comisionComercial =
                      valoresMensualesComisionComercial.comisionesPorOportunidad[opp.id]?.comisionComercial || 0;
                    const ejecutivo = opp.ejecutivo ? users[opp.ejecutivo] || "Sin Ejecutivo" : "Sin Ejecutivo";
                    if (
                      !gerenteIds.includes(parseInt(opp.ejecutivo)) &&
                      !(opp.ejecutivo === "32" && facturaDate >= new Date("2025-06-01"))
                    ) {
                      acc[ejecutivo] = (acc[ejecutivo] || 0) + comisionComercial;
                    }
                    return acc;
                  }, {})
              ).map(([ejecutivo, total]) => (
                <div key={ejecutivo} className={styles.comercialSummaryItem}>
                  <strong>{ejecutivo}:</strong> {formatCurrency(total)}
                </div>
              ))}
            </div>

            {/* TABLA DETALLE */}
            <table className={styles.modalTable}>
              <thead>
                <tr>
                  <th className={styles.comercialNumeroHeader}>Número Factura</th>
                  <th className={styles.comercialClienteHeader}>Cliente Facturado</th>
                  <th className={styles.comercialEjecutivoHeader}>Ejecutivo Asociado</th>
                  <th className={styles.comercialImporteHeader}>Importe Facturado</th>
                  <th className={styles.comercialAgenciaHeader}>Comisión Agencia</th>
                  <th className={styles.comercialEdificioHeader}>Comisión Edificio</th>
                  <th className={styles.comercialNetoHeader}>Importe Neto</th>
                  <th className={styles.comercialPorcentajeHeader}>Comisión %</th>
                  <th className={styles.comercialLocalHeader}>Comisión {getMoneda()}</th>
                </tr>
              </thead>
              <tbody>
                {oportunidades
                  .filter(
                    (opp) =>
                      opp.estatus === "100%" &&
                      !opp.eliminada &&
                      opp.facturafecha &&
                      !isNaN(new Date(opp.facturafecha).getTime()) &&
                      new Date(opp.facturafecha).getMonth() === selectedCommercialMonth
                  )
                  .map((oportunidad) => {
                    const facturaDate = new Date(oportunidad.facturafecha);
                    const importeBruto = parseFloat(oportunidad.importe) || 0;
                    const comisionAgenciaRow = comisionesAgenciaPorMes[selectedCommercialMonth].find(
                      (item) => item.facturanumero === oportunidad.facturanumero && item.oppId === oportunidad.id
                    );
                    const comisionAgencia = comisionAgenciaRow ? comisionAgenciaRow.comision : 0;
                    const comisionEdificiosRow = comisionesEdificiosPorMes[selectedCommercialMonth].find(
                      (item) => item.facturanumero === oportunidad.facturanumero && item.oppId === oportunidad.id
                    );
                    const comisionEdificios = comisionEdificiosRow ? comisionEdificiosRow.totalComision : 0;
                    const importeNeto = importeBruto - comisionAgencia - comisionEdificios;
                    const comisionComercialData =
                      valoresMensualesComisionComercial.comisionesPorOportunidad[oportunidad.id];
                    const comisionComercial = comisionComercialData?.comisionComercial || 0;
                    const comisionPorcentaje =
                      gerenteIds.includes(parseInt(oportunidad.ejecutivo)) ||
                      (oportunidad.ejecutivo === "32" && facturaDate >= new Date("2025-06-01"))
                        ? "-"
                        : oportunidad.pais === "Perú"
                          ? "12.5% + 3.75% (Ene-Jun) + 2.5% (Mar 2025+ para 306) + 1% (Jul+) + 2.5% (Jul+ con 45,23,43)"
                          : oportunidad.pais === "Chile" && oportunidad.ejecutivo
                            ? `${
                                facturaDate.getFullYear() === 2025
                                  ? facturaDate.getMonth() <= 2
                                    ? "8%"
                                    : facturaDate.getMonth() <= 5
                                      ? "7%"
                                      : facturaDate.getMonth() <= 8
                                        ? "6%"
                                        : "5%"
                                  : facturaDate.getFullYear() === 2026
                                    ? facturaDate.getMonth() <= 2
                                      ? "4%"
                                      : facturaDate.getMonth() <= 5
                                        ? "3%"
                                        : "2%"
                                    : "0%"
                              }`
                            : "0%";

                    return (
                      <tr key={oportunidad.id}>
                        <td className={styles.comercialNumeroData}>{oportunidad.facturanumero}</td>
                        <td className={styles.comercialClienteData}>{oportunidad.cliente || "Sin cliente"}</td>
                        <td className={styles.comercialEjecutivoData}>
                          {oportunidad.ejecutivo ? users[oportunidad.ejecutivo] || "Sin Ejecutivo" : "Sin Ejecutivo"}
                        </td>
                        <td className={styles.comercialImporteData}>{formatCurrency(importeBruto)}</td>
                        <td className={styles.comercialAgenciaData}>{formatCurrency(comisionAgencia)}</td>
                        <td className={styles.comercialEdificioData}>{formatCurrency(comisionEdificios)}</td>
                        <td className={styles.comercialNetoData}>{formatCurrency(Math.max(0, importeNeto))}</td>
                        <td className={styles.comercialPorcentajeData}>{comisionPorcentaje}</td>
                        <td className={styles.comercialLocalData}>
                          {comisionComercial === 0 &&
                          (gerenteIds.includes(parseInt(oportunidad.ejecutivo)) ||
                            (oportunidad.ejecutivo === "32" && facturaDate >= new Date("2025-06-01")))
                            ? "-"
                            : formatCurrency(comisionComercial)}
                        </td>
                      </tr>
                    );
                  })}

                {/* TOTAL */}
                {oportunidades
                  .filter(
                    (opp) =>
                      opp.estatus === "100%" &&
                      !opp.eliminada &&
                      opp.facturafecha &&
                      !isNaN(new Date(opp.facturafecha).getTime()) &&
                      new Date(opp.facturafecha).getMonth() === selectedCommercialMonth &&
                      !gerenteIds.includes(parseInt(opp.ejecutivo))
                  )
                  .reduce(
                    (acc, opp) =>
                      acc +
                      (valoresMensualesComisionComercial.comisionesPorOportunidad[opp.id]?.comisionComercial || 0),
                    0
                  ) > 0 && (
                  <tr className={styles.modalTotal}>
                    <td colSpan="8" />
                    <td className={styles.comercialLocalData}>
                      <strong>
                        {formatCurrency(
                          oportunidades
                            .filter(
                              (opp) =>
                                opp.estatus === "100%" &&
                                !opp.eliminada &&
                                opp.facturafecha &&
                                !isNaN(new Date(opp.facturafecha).getTime()) &&
                                new Date(opp.facturafecha).getMonth() === selectedCommercialMonth &&
                                !gerenteIds.includes(parseInt(opp.ejecutivo))
                            )
                            .reduce(
                              (acc, opp) =>
                                acc +
                                (valoresMensualesComisionComercial.comisionesPorOportunidad[opp.id]
                                  ?.comisionComercial || 0),
                              0
                            )
                        )}
                      </strong>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className={styles.modalActions}>
              <button className={styles.btnClose} onClick={closeCommercialModal}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
      {/* === MODAL: COSTOS HARDWARE (COMPRA + OTROS) === */}
      {isHardwareDetailModalOpen && selectedHardwareMonth !== null && (
        <div className={styles.modalOverlay} onClick={closeHardwareDetailModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <h3>
              Costos Hardware - {meses[selectedHardwareMonth]} {currentYear}
            </h3>

            {/* Solo mostrar si el mes es vencido */}
            {selectedHardwareMonth < currentMonth ? (
              <div className={styles.hardwareTableContainer}>
                <table className={styles.modalTable}>
                  <thead>
                    <tr>
                      <th className={styles.hardwareIdHeader}>ID</th>
                      <th className={styles.hardwareNombreHeader}>Cliente / Edificio</th>
                      <th className={styles.hardwareCostoHeader}>Compra {getMoneda()}</th>
                      <th className={styles.hardwareOtrosHeader}>Otros {getMoneda()}</th>
                      <th className={styles.hardwareAccionHeader}>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {negociosDelMes.map((n) => {
                      const registro = costosHardwareData.find(
                        (c) => c.negocio_id == n.id && parseInt(c.mes, 10) === selectedHardwareMonth + 1
                      );

                      const compraActual = registro?.compra_hardware || 0;
                      const otrosActual = registro?.otros_costos || 0;

                      return (
                        <tr key={n.id}>
                          <td className={styles.hardwareIdData}>{n.id}</td>
                          <td className={styles.hardwareNombreData}>{getNombreNegocio(n)}</td>

                          {/* COMPRA HARDWARE */}
                          <td className={styles.hardwareCostoData}>
                            {editandoCosto === n.id ? (
                              <div className={styles.inputGroupInline}>
                                <span className={styles.inputPrefix}>{getMoneda()}</span>
                                <input
                                  type="number"
                                  value={nuevoCosto}
                                  onChange={(e) => setNuevoCosto(e.target.value)}
                                  min="0"
                                  step="0.01"
                                  className={styles.inputInline}
                                  autoFocus
                                />
                              </div>
                            ) : (
                              <span className={compraActual > 0 ? styles.valueBold : styles.valueZero}>
                                {formatCurrency(compraActual)}
                              </span>
                            )}
                          </td>

                          {/* OTROS COSTOS */}
                          <td className={styles.hardwareOtrosData}>
                            {editandoCosto === n.id ? (
                              <div className={styles.inputGroupInline}>
                                <span className={styles.inputPrefix}>{getMoneda()}</span>
                                <input
                                  type="number"
                                  value={nuevoOtros}
                                  onChange={(e) => setNuevoOtros(e.target.value)}
                                  min="0"
                                  step="0.01"
                                  className={styles.inputInline}
                                />
                              </div>
                            ) : (
                              <span className={otrosActual > 0 ? styles.valueBold : styles.valueZero}>
                                {formatCurrency(otrosActual)}
                              </span>
                            )}
                          </td>

                          {/* ACCIÓN */}
                          <td className={styles.hardwareAccionData}>
                            {editandoCosto === n.id ? (
                              <div className={styles.inlineActions}>
                                <button className={styles.btnSaveMini} onClick={() => guardarCosto(n.id)}>
                                  Guardar
                                </button>
                                <button
                                  className={styles.btnCancelMini}
                                  onClick={() => {
                                    setEditandoCosto(null);
                                    setNuevoCosto("");
                                    setNuevoOtros("");
                                  }}
                                >
                                  Cancelar
                                </button>
                              </div>
                            ) : (
                              <button
                                className={styles.btnEditMini}
                                onClick={() => {
                                  setEditandoCosto(n.id);
                                  setNuevoCosto(compraActual.toString());
                                  setNuevoOtros(otrosActual.toString());
                                }}
                              >
                                Editar
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <p style={{ textAlign: "center", color: "#666", fontStyle: "italic" }}>
                No se pueden editar costos de meses futuros.
              </p>
            )}

            <div className={styles.modalActions}>
              <button className={styles.btnClose} onClick={closeHardwareDetailModal}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
      {isEditModalOpen && editingConcept && (
        <div className={styles.modalOverlay} onClick={closeEditModal}>
          <div className={`${styles.modalContent} ${styles.editCostModal}`} onClick={(e) => e.stopPropagation()}>
            <h3 className={styles.modalTitle}>
              Editar {editingConcept.concept} - {meses[editingConcept.month - 1]} {currentYear}
            </h3>

            <div className={styles.inputGroup}>
              <span className={styles.inputPrefix}>{getMoneda()}</span>
              <input
                type="number"
                value={editValue || 0}
                onChange={(e) => setEditValue(parseFloat(e.target.value) || 0)}
                min="0"
                step="0.01"
                placeholder="0"
              />
            </div>

            <div className={styles.modalActions}>
              <button className={styles.btnSave} onClick={saveCost}>
                Guardar
              </button>
              <button className={styles.btnCancel} onClick={closeEditModal}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
      {isGestionContenidosModalOpen && selectedGestionContenidosMonth !== null && (
        <div className={styles.modalOverlay} onClick={closeGestionContenidosModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <h3>
              Detalle Gestión y Contenidos - {mesesCompletos[selectedGestionContenidosMonth]} {currentYear}
            </h3>
            <div style={{ overflowX: "auto" }}>
              <table className={styles.modalTable}>
                <thead>
                  <tr>
                    <th className={styles.gestionIdHeader}>ID</th>
                    <th className={styles.gestionTipoHeader}>Tipo</th>
                    <th className={styles.gestionNombreHeader}>Cliente / Edificio</th>
                    <th className={styles.gestionPantallasHeader}>Pantallas</th>
                    <th className={styles.gestionFeeHeader}>Fee Gestión</th>
                    <th className={styles.gestionFeeHeader}>Fee Contenidos</th>
                    <th className={styles.gestionTotalHeader}>Total {getMoneda()}</th>
                  </tr>
                </thead>
                <tbody>
                  {detalleGestionContenidosPorMes[selectedGestionContenidosMonth].map((item) => (
                    <tr key={item.id}>
                      <td className={styles.gestionIdData}>{item.id}</td>
                      <td className={styles.gestionTipoData}>{item.tipo}</td>
                      <td className={styles.gestionNombreData}>{item.nombre}</td>
                      <td className={styles.gestionPantallasData}>{item.pantallas}</td>
                      <td className={styles.gestionFeeData}>
                        {item.gestionUnitario > 0 ? formatFee(item.gestionUnitario, item.gestionMoneda) : "-"}
                      </td>
                      <td className={styles.gestionFeeData}>
                        {item.contenidosUnitario > 0 ? formatFee(item.contenidosUnitario, item.contenidosMoneda) : "-"}
                      </td>
                      <td className={styles.gestionTotalData}>
                        {formatCurrency(item.totalLocal)} {/* Total en $ o S/ */}
                      </td>
                    </tr>
                  ))}
                  <tr className={styles.modalTotal}>
                    <td colSpan="7" className={styles.gestionTotalData}>
                      <strong>
                        {formatCurrency(
                          detalleGestionContenidosPorMes[selectedGestionContenidosMonth].reduce(
                            (sum, item) => sum + item.totalLocal,
                            0
                          )
                        )}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className={styles.modalActions}>
              <button className={styles.btnClose} onClick={closeGestionContenidosModal}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
